export default __webpack_public_path__ + "static/SohneIkon-Buch-f93be9e5b3aae7d203552260cbb860b7.woff2";